<template>
    <div class="link-auto-table-filter-input-number">
        <link-input-number shape="none"
                           class="link-auto-table-filter-number-input-start"
                           placeholder="最小值"
                           :type="type"
                           :color="color"
                           :size="size"
                           v-model="filterValue.startNumber"
                           :width="90"
                           :show-icon="false"
                           @enter="handleEnter"
        />
        &nbsp;~&nbsp;
        <link-input-number shape="none"
                           placeholder="最大值"
                           :type="type"
                           :color="color"
                           :size="size"
                           v-model="filterValue.endNumber"
                           :width="90"
                           :show-icon="false"
                           @enter="handleEnter"
        />
    </div>
</template>

<script>

    export default {
        name: "link-auto-table-filter-input-number",
        props: {
            size: {type: String,},
            type: {type: String,},
            color: {type: String,},

            field: {},
            filterValue: {},
        },
        methods: {
            handleEnter() {
                this.$emit('confirm', {type: 'number', filtersRaw: this.getValue()});
            },
            getValue() {
                const ret = [];
                this.filterValue.startNumber != null && ret.push({id: this.field, property: this.field, operator: '>=', value: this.filterValue.startNumber});
                this.filterValue.endNumber != null && ret.push({id: this.field, property: this.field, operator: '<=', value: this.filterValue.endNumber});
                return ret
            },
        }
    }
</script>

<style lang="scss">
    .link-auto-table-filter-input-number {
        display: flex;
        align-items: center;
        width: 218px;

        input {
            text-align: center;
        }

        .link-input-number {
            flex: 1;
        }
    }
</style>
